import * as PIXI from "pixi.js";
import Game from "../../../../src/Game";
import Layers from "../../../../src/layers/Layers";
import Switcher from "../../../../src/entities/UI/Switcher";
import { EventBus, EnumEventBus } from "../managers/EventBus";
import { RootEventBus, EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import { QUASIMODO_CON_COORD } from "../types/Config";


export default class QuasimodoModeSwitcherCon extends PIXI.Container {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private RootEventBus = RootEventBus;
  private EventBus = EventBus;
  private Switcher: Switcher;

  constructor() {
    super();
    const coord = this.getCoord();
    Object.assign(this, coord);
    this.addSwitcher();
    this.addHeader();
    this.addToLayer();
    this.RootEventBus.on(EnumRootEventBus.startIntroAnim, () => this.setVisible(false));
    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.setVisible(true));
  }

  addToLayer = () => this.Layers.UI.addChild(this);
  handleFunc = (isActive: boolean) => this.EventBus.emit(EnumEventBus.quasimodoMode, isActive);
  setVisible = (v: boolean) => this.visible = v;

  addHeader() {
    const header = new PIXI.Text({ text: "Quasimodo Mode: " });
    header.style.wordWrap = true;
    header.style.wordWrapWidth = 250;
    header.anchor.set(.5);
    header.y = -54;
    this.addChild(header);
  }
  addSwitcher() {
    const dim = this.Game.getDim();
    this.Switcher = new Switcher(0x55E39F, this.handleFunc, true);
    this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
    this.addChild(this.Switcher);
  }
  getCoord() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return QUASIMODO_CON_COORD
    }

    return {
      x: dim.WIDTH / 2 - 200,
      y: dim.HEIGHT / 2 + 630
    }
  }
}